import { Children, createContext, FC, ReactNode } from 'react';

type StaggerFadeInProps = {
  children: ReactNode;
  className?: string;
};

const STAGGER_STEP_SECONDS = 0.06;

// Each direct child gets its entrance delay through context, so StaggerFadeIn adds no
// wrapper elements that would break the parent's grid / flex layout.
export const StaggerDelayContext = createContext(0);

export const StaggerFadeIn: FC<StaggerFadeInProps> = ({ children, className }) => (
  <div className={className}>
    {Children.map(children, (child, index) => (
      <StaggerDelayContext.Provider value={index * STAGGER_STEP_SECONDS}>
        {child}
      </StaggerDelayContext.Provider>
    ))}
  </div>
);
